export interface API {
  get: (url: string, headers: HeadersInit) => Promise<any>;
  post: (url: string, headers: HeadersInit, body: any) => Promise<any>;
}

type RequestBodyAdapter = (body: any) => BodyInit;

const JSONMiddleware = async (res: Response) => {
  if (res.ok) {
    const data = await res.json();

    if (data.status === 'ERROR') {
      throw new Error(data.message);
    }

    return data;
  }

  throw new Error(res.statusText);
};

class BaseApi implements API {
  private readonly headers: HeadersInit;
  private readonly requestBodyAdapter: RequestBodyAdapter;
  private readonly url: string;

  constructor(
    url: string,
    requestBodyAdapter: RequestBodyAdapter,
    headers: HeadersInit = {}
  ) {
    this.url = url;
    this.requestBodyAdapter = requestBodyAdapter;
    this.headers = headers;
  }

  protected getHeaders() {
    return this.headers;
  }

  protected getRequestBodyAdapter() {
    return this.requestBodyAdapter;
  }

  protected getMiddleware() {
    return JSONMiddleware;
  }

  private getURL() {
    return this.url;
  }

  get(url: string, headers: HeadersInit = {}) {
    return fetch(this.getURL() + url, {
      headers: {
        ...this.getHeaders(),
        ...headers,
      },
    }).then(this.getMiddleware());
  }

  post(url: string, headers: HeadersInit = {}, body?: any) {
    return fetch(this.getURL() + url, {
      method: 'POST',
      headers: {
        ...this.getHeaders(),
        ...headers,
      },
      body: this.getRequestBodyAdapter()(body),
    }).then(this.getMiddleware());
  }
}

export const api = new BaseApi(
  process.env.REACT_APP_API_URL || `${window.top?.location.origin || ''}/api`,
  (body = {}) => JSON.stringify(body),
  { 'Content-Type': 'application/json' }
);

export const formDataApi = new BaseApi(
  process.env.REACT_APP_API_URL || `${window.top?.location.origin || ''}/api`,
  (body) => body
);
